import { addTyped } from '../../metaData';
import { MetadataModules } from '../../enums';
export function addDicomWebInstance(imageId, metadata) {
    return addTyped(MetadataModules.NATURALIZED, imageId, {
        dicomwebJson: metadata,
    });
}
export async function addDicomPart10Instance(imageId, part10) {
    return addTyped(MetadataModules.NATURALIZED, imageId, {
        part10Buffer: part10,
    });
}
